(ns manatee.user.subs
  (:require
   [manatee.user.app-db :as user-db]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::admin?
 (fn admin?
   [db _]
   (user-db/admin? db)))

(rf/reg-sub
 ::project-owner?
 (fn project-owner?
   [db _]
   (user-db/project-owner? db)))

(rf/reg-sub
 ::senior-annotator?
 (fn senior-annotator?
   [db _]
   (user-db/senior-annotator? db)))

(rf/reg-sub
 ::logged-in?
 (fn logged-in?
   [db _]
   (user-db/logged-in? db)))

(rf/reg-sub
 ::logging-in?
 (fn logging-in?
   [db _]
   (user-db/logging-in? db)))

(rf/reg-sub
 ::user
 (fn user
   [db _]
   (user-db/get-user db)))

(rf/reg-sub
 ::evaluator?
 (fn evaluator?
   [db _]
   (user-db/evaluator? db)))

(rf/reg-sub
 ::feature-enabled?
 (fn feature-enabled?
   [db feature]
   (some #{feature}
         (user-db/get-features db))))
